import { hasCapability, type User } from "../base";

export const permittingEntity = {
  view: (user: User) => hasCapability(user, "permittingEntity.view"),
};
